import React from 'react';

import SuperSearchDropdown from 'NewComponents/FormComponents/SuperSearchDropdown/SuperSearchDropdown';
import AccountNumSuperSearchInput from './AccountNumSuperSearchInput';
import AccountNumSuperSearchTemplate from './AccountNumSuperSearchTemplate';
import CustomLabel from 'Common/CustomLabel/CustomLabel';

const AccountNumSuperSearch = ({ label, labelRequired, searchValue, onChange, handleSelectedData, disabled, placeholder, customData, onKeyPress }) => {
  return (
    <div className='w-full flex flex-col gap-2'>
      {label ? (
        <CustomLabel label={label} required={labelRequired} />
      ) : null}
      <SuperSearchDropdown handleSelectedData={handleSelectedData}>
        <SuperSearchDropdown.Input>
          <AccountNumSuperSearchInput
            disabled={disabled}
            searchValue={searchValue}
            onChange={onChange}
            handleSelectedData={handleSelectedData}
            identifier='AccountNumSuperSearch'
            placeholder={placeholder}
            customData={customData}
            onKeyPress={onKeyPress}
          />
        </SuperSearchDropdown.Input>
        <SuperSearchDropdown.Container>
          <AccountNumSuperSearchTemplate width='100%' handleSelectedData={handleSelectedData} identifier='AccountNumSuperSearch' />
        </SuperSearchDropdown.Container>
      </SuperSearchDropdown>
    </div>
  );
};

export default AccountNumSuperSearch;
